import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { loadTokenConfig } from '../../../lib/redux/sheets/slice';
import { useGetWindowMessages } from '../useGetWindowMessages';
import { useSpreadsheetAuth } from '../useSpreadsheetAuth';
import { useSpreadsheetRequestHandler } from '../useSpreadsheetRequestHandler';
import { GoogleSignInButton } from './GoogleSignInButton';
import { VerifyingAccess } from './VerifyingAccess';
import { SignOutButton } from './SignOutButton';
import { FileAccessNeeded } from './FileAccessNeeded';
import { AccessGranted } from './AccessGranted';
import { useCallLogHandler } from '../useCallLogHandler';
import { useEnsureTrellusColumns } from '../useEnsureTrellusColumns';

export function GoogleSheetsOAuthComponent() {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.googleSheets.auth);
  const windowMessages = useSelector((state: RootState) => state.googleSheets.windowMessages);
  const spreadsheetData = useSelector((state: RootState) => state.googleSheets.spreadsheetData);
  
  useGetWindowMessages();
  useSpreadsheetAuth();
  useEnsureTrellusColumns();
  useSpreadsheetRequestHandler();
  useCallLogHandler()
  
  const hasAccess = windowMessages.latestSpreadsheetIdRequested 
    ? spreadsheetData.spreadsheetAccess.includes(windowMessages.latestSpreadsheetIdRequested)
    : false;

  useEffect(() => {
    loadTokenConfig(dispatch);
  }, [dispatch]);

  return (
    <div className="max-w-sm mx-auto p-4 text-center">
      {auth.isVerifying && <VerifyingAccess />}
      {!auth.isSignedIn && !auth.isVerifying ? <GoogleSignInButton /> : null}
      {auth.isSignedIn && windowMessages.latestSpreadsheetIdRequested && !hasAccess ? <FileAccessNeeded /> : null}
      {auth.isSignedIn && windowMessages.latestSpreadsheetIdRequested && hasAccess ? <AccessGranted /> : null}
      {auth.isSignedIn ? <SignOutButton /> : null}
    </div>
  );
} 